<style lang="scss">
  @import './edit-name-move.scss';
</style>
<template>
  <div>
    <template v-if="noEdit">
        <div class="edit-name-move" @mouseenter="editShow" @mouseleave="editShow">
            <div :title="name" class="edit-name-move-name textEllipsis">{{ name == ''? '--': name }}</div>
            <div class="edit-name-move-edit">ssss
                <Icon type="ios-create-outline" v-show="showEdit" class="edit-name-move-edit" @click.native="startEdit" size="16"></Icon>
            </div>
        </div>
    </template>
    <template v-else>
        <div class="edit-name-move">
            <i-input v-model="changeName" style="width:140px;" placeholder="请输入..." size="small"></i-input>
            <i-button type="info" size="small" @click="onChangeName">{{ $t('filter.confirm') }}</i-button>
            <i-button type="text" size="small" @click="closeEdit">{{ $t('filter.cancel') }}</i-button>
        </div>
    </template>
  </div>
</template>
<script>
import bus from '../../libs/bus';
import $ from '../../libs/util';

export default {
  props: {
    name: {
      type: String,
      default: '--',
    },
    eventid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showEdit: false,
      noEdit: true,
      oldName: this.name,
      changeName: '',
    };
  },
  computed: {},
  mounted() {
    const self = this;
    bus.$on('on-close-edit', (id) => {
      if (id !== self.eventid) self.closeEdit();
    });
  },
  beforeDestroy() {
    bus.$off('on-close-edit');
  },
  methods: {
    editShow() {
      this.showEdit = !this.showEdit;
    },
    startEdit() {
      const self = this;
      self.noEdit = false;
      self.$nextTick(() => {
        this.$emit('on-change-edit', this.eventid);
      });
    },
    closeEdit() {
      this.noEdit = true;
      this.showEdit = false;
      this.changeName = '';
    },
    onChangeName() {
      /*
      ** demo环境下不允许增删改
      **/
      if (bus.demoTip()) return;
      const params = {
        platformid: bus.platform.toString(),
        productid: bus.productInfo.productid,
        eventid: this.eventid,
        newName: this.changeName,
      };
      $.ajax.get('app/rest/eventManager/renameEvent', { params })
      .then((res) => {
        if (res) {
          this.oldName = this.changeName;
          this.$emit('on-change-name-succ', this.eventid, this.changeName);
          this.closeEdit();
        }
      });
    },
  },
};
</script>
